<p-toast position="bottom-right"></p-toast>

<p-dialog
    [(visible)]="displayDialog"
    [style]="{ width: '90vw' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="onDialogClosed()"
    header="Ciudades de la Zona"
>
        <div class="card-header mb-4">
            <div class="search-section">
                <div class="button-section">
                    <span class="p-input-icon-left search-input">
                        <i class="pi pi-search"></i>
                        <input
                            pInputText
                            type="text"
                            (input)="table.filterGlobal($event.target.value, 'contains')"
                            placeholder="Buscar..."
                            class="p-inputtext-sm"
                        appPermissionControl="P262K0001">
                    </span>
                    <button mat-flat-button class="btn-new" (click)="openNuevo()" [disabled]="!zona" appPermissionControl="P262B0001">
                        <mat-icon>add</mat-icon>
                        Nueva Ciudad
                    </button>
                </div>
            </div>
        </div>

        <p-table
            #table
            [value]="dataSource"
            [columns]="displayedColumns"
            [rows]="rows"
            [first]="first"
            [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[5, 10, 20]"
            [scrollable]="true"
            [scrollHeight]="'calc(100vh - 400px)'"
            styleClass="p-datatable-gridlines"
            [resizableColumns]="true"
            [autoLayout]="true"
            responsiveLayout="scroll"
            [loading]="loading"
            [globalFilterFields]="['zona','descripcion']"
            (onPage)="onPage($event)"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
         appPermissionControl="P262T0001">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P262C0001">
                        {{ col.header }}
                        <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td *ngFor="let col of displayedColumns" class="td-prime">
                        <ng-container [ngSwitch]="col.field">
                            <ng-container *ngSwitchCase="'actions'">
                                <div class="d-flex gap-2 justify-content-center">
                                    <button
                                        pButton
                                        icon="pi pi-eye"
                                        class="p-button-rounded p-button-info p-button-text"
                                        pTooltip="Editar"
                                        (click)="editarCiudad(rowData)"
                                     appPermissionControl="P262B0002"></button>
                                    <button
                                        pButton
                                        icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger p-button-text"
                                        pTooltip="Eliminar"
                                        (click)="eliminarCiudad(rowData)"
                                     appPermissionControl="P262B0003"></button>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{ rowData[col.field] }}
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="displayedColumns.length" class="text-center td-prime">
                        <span *ngIf="dataSource.length === 0 && !loading">No hay datos para mostrar</span>
                        <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                    </td>
                </tr>
            </ng-template>
        </p-table>
</p-dialog>

<!-- Sub-diálogo para alta/edición de ciudad (preparado) -->
<p-dialog
    [(visible)]="displayNuevoDialog"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '30vw', minHeight: '300px', maxHeight: '90vh' }"
    [header]="ciudadSeleccionada ? 'Editar Ciudad' : 'Nueva Ciudad'"
    (onHide)="onNuevoDialogClosed()"
>
    <app-zona-ciudad-form-ciudad
        [zona]="zona"
        [ciudad]="ciudadSeleccionada"
        (onSave)="onNuevoCiudadGuardada($event)"
        (onHide)="onNuevoDialogClosed()"
    ></app-zona-ciudad-form-ciudad>
</p-dialog>

<style>
    :host ::ng-deep .custom-dialog {
        .p-dialog-content {
            padding: 0;
            height: calc(100% - 50px);
        }
    }

    :host ::ng-deep .h-100 {
        height: 100%;
    }
</style> 